import { render, staticRenderFns } from "./list-table-articles.vue?vue&type=template&id=09f3886e&scoped=true"
import script from "./list-table-articles.vue?vue&type=script&lang=js"
export * from "./list-table-articles.vue?vue&type=script&lang=js"
import style0 from "./list-table-articles.vue?vue&type=style&index=0&id=09f3886e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3886e",
  null
  
)

export default component.exports